import React from 'react';
import { Box } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import SkinLangSwitcher from 'c-wrapper/Components/SkinLangSwitcher';

const ContentFooter = () => (
    <Box
        mb={{ xs: 1.5, md: 0 }}
        // borderTop="1px solid rgba(2, 69, 85, 0.2)"
        py={2}
        px={2}
        whiteSpace="pre-line"
    >
        <SkinLangSwitcher />
    </Box>
);

export default ContentFooter;
